import "./Navbar.css";

const navbar = () => {
  return (
    <div className="nav">
      <div className="nav-contents">
        <div className="logo-nav">
          <img className="img-logo-nav" src="logocnc.png" alt="logo" />
        </div>
        <div className="nav-social-media">
          <a
            target="_blank"
            rel="noreferrer noopener"
            href="https://wa.me/523310684078?text=Hola!%20Me%20interesa%20informaci%C3%B3n"
          >
            <img className="social-img" src="wppimg.png" alt="wpp" />
          </a>
          <a
            target="_blank"
            rel="noreferrer noopener"
            className="social-img"
            href="https://www.instagram.com/cuteandcare.db/"
          >
            <img className="social-img" src="insimg.png" alt="instagram" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default navbar;
